import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';


import { useTranslation } from 'react-i18next'
import auth from '../../../utils/auth';
import request from '../../../utils/request';
import { makeStyles, useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import axios from 'axios';
import cookie from 'react-cookies';

import {
	AppBar,
	Grid,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  TextField,
  Paper,
  InputLabel,
  Input,
} from '@material-ui/core';

import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1)
  },
  topBar:{
		paddingBottom: '8px',
		borderBottom: '1px #dddddd solid',
	},
	whiteLine: {
		borderBottom: '1px #ffffff solid',
		marginBottom:'16px',	
	},
	title: {
		fontSize:'16px',		 
		color:'#73838b', fontWeight:'500',
		padding:'0px',
		[theme.breakpoints.up("md")]: {
			fontSize:'20px',
		},
	},
  desc: {
    margin:"12px 0 12px 0",
    padding:"12px",
    background:"#f5f5f5"
  },
  textField: {
    marginTop: theme.spacing(2),
  },

}));

const ClubMain = props => {

  const pelotonId = props.pelotonId;
  
  const classes = useStyles();
  const theme = useTheme();
  const [createOpen, setCreateOpen] = React.useState(false);
  const createFullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleCreateOpen = () => {
    alert("등록되었습니다");
    setCreateOpen(true);
  };
  const handleCreateClose = () => {
    setCreateOpen(false);
  };

	const token = auth.getToken().token; 
	const extraInfo = auth.getExtraInfo() ? auth.getExtraInfo() : {pretest : 'none'};
	const auth_str = 'Bearer '.concat((auth.getToken().token)); 
	const [ postList, setPostList ] = React.useState([]);

  // 게시글 등록
  const [clubFormData, setClubFormData] = useState({
    name: '',
    description: '',
    country: '',
    city: '',
    category: 0,
  });
  
  // 이미지 파일
  const [imageFiles, setImageFiles] = React.useState([]);

  //다국어적용
  const { t }  = useTranslation(['page']);



  function PostCard(props) {
    const post = props.post; 
    return (
      <Box>포스트포스트</Box>
    )
  }


  //const [popoverOpenInvite, setPopoverOpenInvite] = React.useState(false);
  useEffect(() => {

    // 펠로톤 게시글 가져오기
    axios.get(
      `${process.env.REACT_APP_PELOTON_RESTAPI_BASE_URL}/api/club/post`, 
      { 
        headers: { Authorization: auth_str }, 
        params: { 
          peloton_id: pelotonId,
        }
      }
    ).then(function (response) {
      const items = response.data.response.content;
      setPostList(items); 
    }).catch(function (err) {
      console.log(err);
    })

  }, []);

  // 펠로톤 클럽 등록
  const handlePostSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = new FormData();
    dataToSend.append('data', JSON.stringify(clubFormData)); // JSON 데이터를 'data' 키에 문자열로 추가

    // 이미지 파일 추가
    imageFiles.forEach((file) => {
      dataToSend.append('files', file, file.name);
    });

    dataToSend.append('pelotonId', pelotonId);

    try {
      const response = await axios.post(`${process.env.REACT_APP_PELOTON_RESTAPI_BASE_URL}/api/club`, dataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: auth_str
        }
      });
      console.log('Response:', response.data);
      if(response.data.success){
        alert('게시글이 등록되었습니다.');
        handleCreateClose();
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  }

  return (
    <React.Fragment>
      <Paper style={{padding:'16px'}}>
          <Box style={{textAlign:'center'}}> 
            <Button variant="contained" color="primary" onClick={handleCreateOpen}>게시글 올리기</Button>
          </Box>
      </Paper>

      <Box style={{"margin":"12px 0"}}>    
      </Box>
  
      <Box style={{"margin":"12px 0"}}>    
			<Grid container spacing={2}>
        {postList.map((post, i) => (								
          <Grid item lg={4} md={6} sm={6} xs={12} key={i}>
            <PostCard post={post}></PostCard>
          </Grid>
				))}
			</Grid>
      </Box>
    </React.Fragment>
  );
};

ClubMain.propTypes = {
  history: PropTypes.object
};

export default ClubMain;
